




import axios from "axios";
import { $store } from "@/store";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class LoaderView extends Vue {
  async mounted() {
    // Set overlay to true to show loading animation
    $store.appearance.overlay = true;
    // Fetch wizard instance
    const [wizard, err1] = await $store.wizardInstances.fetch(
      this.$route.params.id
    );
    if (wizard && !["success", "failed"].includes(wizard.state)) {
      // If wizard is found and in the correct state, set axios interceptor.
      axios.interceptors.request.use(function (config) {
        if (config.headers) {
          config.headers["x-wizard-instance"] = wizard?.id as string;
        } else {
          config.headers = { "x-wizard-instance": wizard?.id as string };
        }
        return config;
      });
      // TODO check template configs
      // Check layout config
      if (wizard.config.layout) {
        $store.wizard.layoutActive = true;
        if (wizard.config.layout.action == "edit") {
          // Fetch layout for editing
          const [_, err2] = await $store.layouts.fetch(
            wizard.config.layout.ref
          );
          if (err2) {
            console.log(err2);
            $store.appearance.overlay = false;
            // TODO Redirect to error
          }
        } else {
          // Create a new empty layout
          $store.layouts.create();
          // If a layoutSource reference is present, fetch it
          if (wizard.config.layout?.layoutSource) {
            // Fetch layoutSource
            const [_, err3] = await $store.layoutSources.fetch(
              wizard.config.layout.layoutSource
            );
            $store.wizard.layoutStep = 1;
            if (err3) {
              console.log(err3);
              $store.appearance.overlay = false;
              // TODO Redirect to error
            }
          } else {
            $store.wizard.layoutStep = 2;
          }
        }
      }
      $store.appearance.overlay = false;
      // Set wizard state to ready
      $store.wizard.ready = true;
      // Route to layout wizard
      this.$router.push({
        name: "layout_wizard",
        params: { id: this.$route.params.id },
      });
    } else {
      $store.appearance.overlay = false;
      console.log(err1);
      // TODO Redirect to error
    }
  }
}
